/*
standard drop-down selector component for Warehouses
*/

import { AppConfig } from 'src/app/app-config.service';
import { ChangeDetectorRef, Component, Input, OnInit, AfterViewChecked, ViewChild, AfterViewInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
const warehouseSessionKey = 'mayer-current-warehouse';

@Component({
  selector: 'mayer-warehouse-selector',
  templateUrl: './warehouse-selector.component.html',
  styleUrls: ['./warehouse-selector.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: WarehouseSelectorComponent
    }
  ]
})
export class WarehouseSelectorComponent implements AfterViewInit, AfterViewChecked,
  // https://blog.angular-university.io/angular-custom-form-controls/
  ControlValueAccessor {

  @ViewChild('selector') private selectorControl!: MatSelect;
  selectorFormControl = new FormControl();
  warehouses = AppConfig.settings.acumatica.Warehouses;

  constructor(private changeDetector: ChangeDetectorRef) { }

  ngAfterViewInit(): void {
    setTimeout(() => {
      // initialize selector from browser stored value
      let whseID = localStorage.getItem(warehouseSessionKey) || null;
      this.selectorFormControl.setValue(whseID);
      this.onChange(whseID);

      // when the selector is changed through the form control
      this.selectorFormControl.valueChanges.subscribe(value => {
        // store the new value in browser storage
        if (value !== null) localStorage.setItem(warehouseSessionKey, value);
        else localStorage.removeItem(warehouseSessionKey);
        // notify container components of change
        this.onChange(value);
      });
    }, 10)
  }

  ngAfterViewChecked(): void {
    this.changeDetector.detectChanges();
  }

  public setOptions(WarehouseIDs: string[]) {
    this.warehouses = AppConfig.settings.acumatica.Warehouses
      .filter(value => WarehouseIDs.indexOf(value.id) != -1);
  }

  // #region ControlValueAccessor
  writeValue(value: any): void {
    if (value) this.value = value;
  }

  onChange = (value: any) => { };
  registerOnChange(fn: any): void {
    this.onChange = fn;
    this.onChange(this.value);
  }

  onTouched: any;
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  // #endregion

  // map this component's "value" property to the selector form control value
  @Input()
  get value(): string | null { return this.selectorFormControl.value; }
  set value(value) {
    this.selectorFormControl.setValue(value);
    this.onChange(value);
  }

  // method to set focus to the selector
  focus() {
    this.selectorControl?.focus();
  }
}